import "./SearchBar.css";
import { FaSearch, FaFilter } from "react-icons/fa";

function SearchBar({ searchQuery, setSearchQuery, filterMode, setFilterMode }) {
  const filterOptions = ["All", "Online", "Offline", "Hybrid"];

  const handleFilterToggle = () => {
    const currentIndex = filterOptions.indexOf(filterMode);
    const nextIndex = (currentIndex + 1) % filterOptions.length;
    setFilterMode(filterOptions[nextIndex]);
  };

  return (
    <div
      className="student-page-searchbar-container"
      data-aos="fade-up"
      data-aos-duration="650"
    >
      <div
        className="student-page-searchbar-input"
        data-aos="fade-right"
        data-aos-delay="60"
        data-aos-duration="600"
      >
        <FaSearch className="student-page-searchbar-search-icon" />
        <input
          type="text"
          placeholder="Search courses..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <button
        type="button"
        className="student-page-searchbar-filter-button"
    
    
        onClick={handleFilterToggle}
        aria-label={`Filter courses by ${filterMode}`}
      >
        <FaFilter />
        {`Filter: ${filterMode}`}
      </button>
    </div>
  );
}

export default SearchBar;
